import { useState, useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import _ from "lodash";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";
import CreateOrderHead from "./CreateOrderHead";
import CreateOrderTableDetail from "./CreateOrderTableDetail";
import CreateOrderDocument from "./Document/CreateOrderDocument";
import CreateOrderButton from "./CreateOrderButton";

import classes from "./createOrder.module.scss";

import { getToday } from "@/services/Utils";

import { useOrderSave, useOrderCreate, useOrderApprove, useOrderReject } from "@/hooks/purchases/orders";

import { baseFilterOrders } from "../orders_constants";
import { baseOrder } from "./createOrder.constants";

const CreateOrder = () => {
	const { option, code } = useParams();

	const { estate_parent_id, estate_id, type_currency, search, parameter } = useSelector((state) => state.auth.filter);

	const [data, setData] = useState({ ...baseOrder });
	const initializedRef = useRef(false);

	const base = { ...baseFilterOrders, estate_parent_id, estate_id, type_currency, search, parameter };
	const params = { estate_parent_id, estate_id, code };

	const { data: response, isLoading, isFetching } = useOrderCreate(params);
	const { mutate: save, isLoading: loadingSave } = useOrderSave(base, params);
	const { mutate: approve, isLoading: loadingApprove } = useOrderApprove(base, params);
	const { mutate: reject, isLoading: loadingReject } = useOrderReject(base, params);

	useEffect(() => {
		if (!response || initializedRef.current) return;

		if (["ver", "editar"].includes(option) && response.order) {
			const orderData = response.order;

			setData((prevData) => ({
				...prevData,
				...orderData,
				code_oc: orderData.code_oc || response.code,
				date_create_order: orderData.date_create_order || getToday(),
				business_id: orderData.business_id || (response.business?.length === 1 ? response.business[0].value : prevData.business_id),
				estate_parent_id:
					orderData.estate_parent_id || (response.estates_parents?.length === 1 ? response.estates_parents[0].value : prevData.estate_parent_id),
				estate_id: orderData.estate_id || (response.estates?.length === 1 ? response.estates[0].value : prevData.estate_id),
			}));

			initializedRef.current = true;
		} else if (option === "ingresar") {
			setData((prevData) => ({
				...prevData,
				code_oc: response.code,
				date_create_order: getToday(),
				business_id: response.business?.length === 1 ? response.business[0].value : prevData.business_id,
				estate_parent_id: response.estates_parents?.length === 1 ? response.estates_parents[0].value : prevData.estate_parent_id,
				estate_id: response.estates?.length === 1 ? response.estates[0].value : prevData.estate_id,
			}));

			initializedRef.current = true;
		}
	}, [response, option]);

	return (
		<>
			<Head
				title={option === "ingresar" ? "Ingresar Orden de Compra" : `${_.capitalize(option)} Orden de Compra`}
				isFetching={isFetching && !isLoading}
			/>

			{isLoading || loadingSave || loadingApprove || loadingReject ? (
				<Fetching />
			) : (
				<Row className={classes.row_global_card}>
					<CreateOrderHead params={params} data={data} setData={setData} />
					<CreateOrderTableDetail params={params} data={data} setData={setData} />
					<CreateOrderDocument data={data} setData={setData} />
					<CreateOrderButton params={params} base={base} data={data} setData={setData} save={save} approve={approve} reject={reject} />
				</Row>
			)}
		</>
	);
};

export default CreateOrder;
